<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'VCascadeEditor',
  extends: compoment
}
</script>
